export default function(object, property) {
  return Object.hasOwn(object, property);
}
